import React from 'react';
import './Menu.scss'
import '../../resources/main.scss'
import menuJson from './menu.json'
import { Link } from "react-router-dom";

class Menu extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            menu: menuJson
        }
    }
    render() {
        return (
            <div className='standard menu'>
                <Link to='/' className='standard__link'><img src='/images/logo.png' alt='logo' className='menu__logo' /></Link>
                <h2 className='menu__title'>Meniu</h2>
                {this.state.menu.map(item => (
                    <div className='menu__section' key={item.id}>
                        <h3 className='menu__subtitle'>{item.section}</h3>
                        {item.items.map(menuItem => (
                            <div className='menu__item' key={menuItem.id}>
                                <div className='menu__food'>
                                    <h4>{menuItem.name}</h4>
                                    <p>{menuItem.description}</p>
                                </div>
                                <h4 className='menu__price'>{menuItem.price}</h4>
                            </div>
                        ))}
                    </div>
                ))}
                <h4 className='menu__see-drinks'
                    onClick={() =>
                        window.open('./images/bauturi.pdf')
                    }
                >
                    {' '}
                    Vezi meniu băuturi
                </h4>

            </div>
        )
    }
}
export default Menu;